import { render, staticRenderFns } from "./purchaseStockReturn.vue?vue&type=template&id=4dc1ae8d&scoped=true"
import script from "./purchaseStockReturn.vue?vue&type=script&lang=js"
export * from "./purchaseStockReturn.vue?vue&type=script&lang=js"
import style0 from "./purchaseStockReturn.vue?vue&type=style&index=0&id=4dc1ae8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1ae8d",
  null
  
)

export default component.exports